var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-page__right-inner"},[_vm._t("header"),_vm._t("body"),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }